// extracted by mini-css-extract-plugin
module.exports = {"intro":"intro-module--intro--5bTT0","wrapper":"intro-module--wrapper--comJv","rotate":"intro-module--rotate--3ZNzA","letter":"intro-module--letter--13P-F"};